module.exports = __webpack_public_path__ + "img/ch44.b462e070.jpg";